export class MenuButton {
  private target?: HTMLButtonElement | null;
  constructor() {
    this.init();
  }

  private init() {
    this.cleanup();
    this.target = document.querySelector<HTMLButtonElement>('#menu-button');
    if (this.target) {
      this.target.addEventListener('click', this.handleClick);
    }
  }

  private cleanup() {
    if (this.target) {
      this.target.removeEventListener('click', this.handleClick);
    }
  }

  private handleClick = (event: MouseEvent) => {
    const target = event.currentTarget as HTMLButtonElement;
    const currentAriaExpanded = target.getAttribute('aria-expanded');
    target.setAttribute(
      'aria-expanded',
      currentAriaExpanded === 'true' ? 'false' : 'true'
    );
    document.body.style.overflow =
      currentAriaExpanded === 'true' ? 'auto' : 'hidden';
  };
}
